import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {CampoData, CampoTexto} from '../../../components/processo/CamposProcesso.jsx';

/* Subaba "Período e termos" da aba Inscrição: datas do processo, termo de ciência e informação adicional. */
export default function TabInscricaoPeriodo({control, errors}) {
    const props = {control, errors};

    return (
        <Grid container spacing={3}>
            <CampoData {...props} nome='dataInicial' rotulo='Data início processo seletivo *' comHora sm={4}/>
            <CampoData {...props} nome='dataFinal' rotulo='Data término processo seletivo *' comHora sm={4}/>
            <CampoData {...props} nome='dataFinalAtualizacaoResultado' rotulo='Data final atualização de resultados *' sm={4}/>
            <CampoTexto {...props} nome='termoCiencia' rotulo='Termo de ciência *' sm={12} multiline/>
            <CampoTexto {...props} nome='informacaoAdicional' rotulo='Informação adicional' sm={12} multiline/>
        </Grid>
    );
}

TabInscricaoPeriodo.propTypes = {
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
